/* ============================================================
   MÉTODO CLARIDAD — Interactivos
     I-2 · Triángulo de los 3 factores (elige 2 de 3)
     I-3 · Explorador C-L-A-R-I-D-A-D
   Vanilla, sin dependencias. Cada bloque sale solo si no existe en el DOM.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     I-2 · TRIÁNGULO DE LOS 3 FACTORES
     Máximo 2 seleccionados. Al elegir un tercero, se suelta el
     más antiguo — así el interactivo nunca se traba.
     --------------------------------------------------------- */
  function initTriangulo() {
    var root = document.querySelector('[data-cl-tri]');
    if (!root) return;

    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-cl-tri-opt]'));
    var results = Array.prototype.slice.call(root.querySelectorAll('[data-cl-tri-result]'));
    var contador = root.querySelector('[data-cl-tri-contador]');
    if (!opts.length || !results.length) return;

    // Orden canónico: la clave del panel siempre se arma en este orden.
    var ORDER = ['zona', 'tamano', 'anio'];
    var selected = [];   // cola: el primero en entrar es el primero en salir

    function keyFor(list) {
      if (list.length < 2) return 'idle';
      return ORDER.filter(function (k) { return list.indexOf(k) !== -1; }).join('+');
    }

    function render() {
      var full = selected.length >= 2;

      opts.forEach(function (btn) {
        var val = btn.getAttribute('data-cl-tri-opt');
        var isOn = selected.indexOf(val) !== -1;
        btn.classList.toggle('is-on', isOn);
        btn.classList.toggle('is-off', full && !isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });

      var key = keyFor(selected);
      results.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-cl-tri-result') === key);
      });

      root.classList.toggle('is-resolved', full);

      // Feedback explicito de progreso: sin esto no se sabe cuanto falta
      if (contador) {
        contador.textContent = full
          ? 'Listo — mira mi recomendación'
          : selected.length + ' de 2 elegidos';
        contador.classList.toggle('is-completo', full);
      }
    }

    // --- Latido de invitacion ---
    // La instruccion escrita solo alcanza a quien lee. El movimiento
    // avisa a quien escanea que la zona es interactiva.
    var yaInteractuo = false;
    function detenerLatido() {
      yaInteractuo = true;
      root.classList.remove('is-hinting');
    }
    if ('IntersectionObserver' in window) {
      var ioHint = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || yaInteractuo) return;
          root.classList.add('is-hinting');
          ioHint.unobserve(e.target);
          // 3 repeticiones de 2.4s + el escalonado de la ultima tarjeta
          window.setTimeout(function () {
            if (!yaInteractuo) root.classList.remove('is-hinting');
          }, 2400 * 3 + 440);
        });
      }, { threshold: 0.35 });
      ioHint.observe(root);
    }

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        detenerLatido();
        var val = btn.getAttribute('data-cl-tri-opt');
        var at = selected.indexOf(val);

        if (at !== -1) {
          selected.splice(at, 1);           // deseleccionar
        } else {
          selected.push(val);
          if (selected.length > 2) selected.shift();   // suelta el más antiguo
        }
        render();
      });
    });

    render();
  }

  /* ---------------------------------------------------------
     I-3 · EXPLORADOR C-L-A-R-I-D-A-D — RETIRADO (2026-09-09).
     La seccion del Metodo dejo de ser un tablist: ahora es un
     indice visible, los ocho modulos de una sola pasada. No hace
     falta JavaScript, asi que la funcion se elimina en vez de
     quedarse ocupando lugar en el archivo que baja el visitante.
     Esta en el historial de git si alguna vez vuelve.
     --------------------------------------------------------- */

  /* ---------------------------------------------------------
     I-4 · DEMO DEL FILTRO CLARIDAD™
     4 preguntas → veredicto. Versión reducida del filtro real de
     12 factores; la página lo dice explícitamente.
       4 sí        → Recomendada
       2-3 sí      → Requiere más análisis
       0-1 sí      → No recomendada (todavía)
     --------------------------------------------------------- */
  function initFiltro() {
    var root = document.querySelector('[data-cl-filter]');
    if (!root) return;

    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-cl-filter-q]'));
    var verdicts = Array.prototype.slice.call(root.querySelectorAll('[data-cl-filter-verdict]'));
    var fill = root.querySelector('[data-cl-filter-fill]');
    var scoreOut = document.querySelector('[data-cl-filter-contador]');
    var reset = root.querySelector('[data-cl-filter-reset]');
    if (!questions.length || !verdicts.length) return;

    // Latido de invitacion, mismo patron que el triangulo.
    var yaRespondio = false;
    if ('IntersectionObserver' in window) {
      var ioF = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || yaRespondio) return;
          root.classList.add('is-hinting');
          ioF.unobserve(e.target);
          window.setTimeout(function () {
            if (!yaRespondio) root.classList.remove('is-hinting');
          }, 2400 * 3 + 200);
        });
      }, { threshold: 0.3 });
      ioF.observe(root);
    }

    var total = questions.length;
    var answers = new Array(total).fill(null);

    function verdictFor(score) {
      if (score === total) return 'ok';
      if (score >= 2) return 'warn';
      return 'bad';
    }

    function render() {
      var answered = answers.filter(function (a) { return a !== null; }).length;
      var score = answers.reduce(function (acc, a) { return acc + (a || 0); }, 0);
      var complete = answered === total;

      if (fill) fill.style.width = (complete ? (score / total) * 100 : 0) + '%';
      if (scoreOut) {
        scoreOut.textContent = complete
          ? 'Listo — este es tu resultado'
          : answered + ' de ' + total + ' respondidas';
        scoreOut.classList.toggle('is-completo', complete);
      }

      var key = complete ? verdictFor(score) : 'idle';
      verdicts.forEach(function (v) {
        v.classList.toggle('is-active', v.getAttribute('data-cl-filter-verdict') === key);
      });

      root.setAttribute('data-cl-filter-state', key);
      if (reset) {
        if (answered > 0) { reset.removeAttribute('hidden'); } else { reset.setAttribute('hidden', ''); }
      }
    }

    questions.forEach(function (q, qi) {
      var btns = Array.prototype.slice.call(q.querySelectorAll('[data-cl-filter-a]'));
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          yaRespondio = true;
          root.classList.remove('is-hinting');
          answers[qi] = parseInt(btn.getAttribute('data-cl-filter-a'), 10);
          btns.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
          q.classList.add('is-answered');
          render();
        });
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        answers = new Array(total).fill(null);
        questions.forEach(function (q) {
          q.classList.remove('is-answered');
          q.querySelectorAll('[data-cl-filter-a]').forEach(function (b) { b.classList.remove('is-on'); });
        });
        render();
      });
    }

    render();
  }

  /* --------------------------------------------------------- */
  function init() {
    initTriangulo();
    initFiltro();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
